import { render } from "./pinpaiyichang.vue?vue&type=template&id=e673cc88&scoped=true"
import script from "./pinpaiyichang.vue?vue&type=script&lang=js"
export * from "./pinpaiyichang.vue?vue&type=script&lang=js"

import "./pinpaiyichang.vue?vue&type=style&index=0&id=e673cc88&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-e673cc88"

export default script